import React, { forwardRef, useState, useEffect, useImperativeHandle } from 'react';
import { useProfileUpdateStore, useProfileStore, isUserTokenPresent } from '@growth/auth-helpers';
import { useApiCall } from '@growth/custom-hooks/useApiCall';
import { fetchUserGeoLocation } from '@growth/api-calls';
import { ToolTip } from '@growth/tooltip';
import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-8a80a17d.esm.js';
import styled from 'styled-components';
import { breakPoints } from '@growth/app-theme';
import { textSizes } from '@growth/design-system';
import Checkbox from '../../Checkbox/dist/growth-billing-details-shared-Checkbox.esm.js';
import InputField from '../../InputField/dist/growth-billing-details-shared-InputField.esm.js';
import { DropDown } from '../../DropDownField/dweb/dist/growth-billing-details-shared-DropDownField-dweb.esm.js';
import { a as stateList, p as pdt, g as getOnceSession, b as setOnceSession, P as Platform, v as validatePincode, c as pincodeErrorMessage, d as checkBoxErrorMessage, e as stateMandatoryMessage, f as apiErrorMessage } from '../../../dist/commonTrackKeys-1035867d.esm.js';
import '@growth/browser-storage';
import '@growth/pdt-track';
import { MwebSearchModal } from '../../DropDownField/mweb/dist/growth-billing-details-shared-DropDownField-mweb.esm.js';
import '@growth/use-analytics';
import '@growth/custom-hooks/useOutsideHandler';
import '@growth/bottom-sheet';
import '@growth/custom-hooks/use100Vh';
import 'react-dom';

var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var Heading = styled.h2(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #000000;\n\tmargin-bottom: 2px;\n\ttext-transform: uppercase;\n\t@media (max-width: ", ") {\n\t\ttext-transform: capitalize;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\t.billing-tooltip {\n\t\tposition: absolute;\n\t\tleft: 95px;\n\t\tbackground: #000000;\n\t\tcolor: white;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 11px;\n\t\tline-height: 14px;\n\t\twidth: 204px;\n\t\tdisplay: none;\n\t}\n\tdiv > .billing-icon:hover + .billing-tooltip {\n\t\tdisplay: block;\n\t}\n"])), textSizes.LargeW3, breakPoints.mobileL);
var HeadingContainer = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n\tbackground: #ffffff;\n\tborder-radius: 4px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 16px;\n\tborder: 0px;\n\tcolor: #000000;\n\theight: 100%;\n"])));
var BillingIcon = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\twidth: 14px;\n\theight: 14px;\n\tvertical-align: middle;\n\tmargin-left: 8px;\n\tcursor: pointer;\n"])));
var EditKey = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tfont-style: normal;\n\t", "\n\tcolor: #2276e3;\n\tcursor: pointer;\n"])), textSizes.SmallW1);
var ArrowKey = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tborder-style: solid;\n\tborder-color: rgb(34, 116, 224);\n\tborder-image: initial;\n\tborder-width: 0px 2px 2px 0px;\n\tdisplay: inline-block;\n\tpadding: 3px;\n\ttransform: rotate(45deg);\n\tmargin-left: 10px;\n"])));
var SubHeading = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #757575;\n\tmargin-bottom: 15px;\n"])), textSizes.SmallW1);
styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\n\t.billing-input-container {\n\t\twidth: 257px;\n\t\theight: 76px;\n\n\t\t@media (max-width: ", ") {\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tmargin-bottom: 24px;\n\t\t}\n\t}\n"])), breakPoints.mobileL);
var ErrorMsg$1 = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tcolor: #ff3a5c;\n\tmargin-top: 2px;\n"])));
var State = styled.p(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n\tfont-style: normal;\n\t", "\n\tcolor: #141823;\n\tmargin-bottom: 16px;\n"])), textSizes.BaseW3);

var _templateObject, _templateObject2;
var BillingForm$1 = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t@media (max-width: ", ") {\n\t\tflex-wrap: wrap;\n\t}\n\n\t.billing-input-container {\n\t\twidth: 257px;\n\t\theight: 76px;\n\n\t\t@media (max-width: ", ") {\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tmargin-bottom: 24px;\n\t\t}\n\t}\n"])), breakPoints.mobileL, breakPoints.mobileL);
var ErrorMsg = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tcolor: #ff3a5c;\n\tmargin-top: 2px;\n"])));

var BillingForm = function BillingForm(_ref) {
  var platform = _ref.platform,
      pincodeErrorMsg = _ref.pincodeErrorMsg,
      stateListSelected = _ref.stateListSelected,
      handleState = _ref.handleState,
      stateErrorMsg = _ref.stateErrorMsg,
      address = _ref.address,
      pincode = _ref.pincode,
      handleAddress = _ref.handleAddress,
      handlePincode = _ref.handlePincode;
  return /*#__PURE__*/React.createElement(BillingForm$1, null, /*#__PURE__*/React.createElement("div", {
    className: "billing-input-container"
  }, /*#__PURE__*/React.createElement(InputField, {
    width: "100%",
    inputType: "text",
    label: "Billing Address",
    inpValue: address,
    handleChange: handleAddress
  })), /*#__PURE__*/React.createElement("div", {
    className: "billing-input-container"
  }, /*#__PURE__*/React.createElement(InputField, {
    width: "100%",
    inputType: "tel",
    label: "Pincode",
    maxLength: 6,
    hasError: !!pincodeErrorMsg,
    inpValue: pincode,
    handleChange: handlePincode
  }), !!pincodeErrorMsg && /*#__PURE__*/React.createElement(ErrorMsg, null, pincodeErrorMsg)), /*#__PURE__*/React.createElement("div", {
    className: "billing-input-container"
  }, platform === 'mweb' ? /*#__PURE__*/React.createElement(MwebSearchModal, {
    listToShow: stateList,
    header: "Select State",
    labelText: "State",
    selectedVal: stateListSelected.name,
    handleOptionSelected: handleState
  }) : /*#__PURE__*/React.createElement(DropDown, {
    labelText: "State",
    width: "100%",
    selectedValue: stateListSelected.name,
    options: stateList,
    handleOptionSelected: handleState
  }), !!stateErrorMsg && /*#__PURE__*/React.createElement(ErrorMsg, null, stateErrorMsg)));
};

var BillingDetails = /*#__PURE__*/forwardRef(function (props, ref) {
  var platform = props.platform,
      onSuccess = props.onSuccess,
      onError = props.onError,
      heading = props.heading,
      subHeading = props.subHeading,
      _props$showInfoIcon = props.showInfoIcon,
      showInfoIcon = _props$showInfoIcon === void 0 ? false : _props$showInfoIcon,
      _props$showEditIcon = props.showEditIcon,
      showEditIcon = _props$showEditIcon === void 0 ? false : _props$showEditIcon,
      _props$openEditMode = props.openEditMode,
      openEditMode = _props$openEditMode === void 0 ? false : _props$openEditMode,
      lobName = props.lobName,
      wrapperCss = props.wrapperCss,
      onLoad = props.onLoad;

  var _useState = useState(openEditMode),
      editMode = _useState[0],
      setEditMode = _useState[1];

  var _useState2 = useState(false),
      checkboxVal = _useState2[0],
      setChecboxVal = _useState2[1];

  var _useState3 = useState(false),
      checkboxError = _useState3[0],
      setCheckboxError = _useState3[1];

  var _useState4 = useState(openEditMode),
      showForm = _useState4[0],
      setShowForm = _useState4[1];

  var _useState5 = useState(''),
      errorMsg = _useState5[0],
      setErrorMsg = _useState5[1];

  var _useState6 = useState(''),
      pincodeErrorMsg = _useState6[0],
      setPincodeErrorMsg = _useState6[1];

  var _useState7 = useState(''),
      stateErrorMsg = _useState7[0],
      setStateErrorMsg = _useState7[1];

  var _useState8 = useState({
    name: '',
    id: ''
  }),
      stateListSelected = _useState8[0],
      setStateListSelected = _useState8[1];

  var _useState9 = useState(''),
      address = _useState9[0],
      setAddress = _useState9[1];

  var _useState10 = useState(''),
      pincode = _useState10[0],
      setPincode = _useState10[1];

  var _useState11 = useState({}),
      billingDetails = _useState11[0],
      setBillingDetails = _useState11[1];

  var _useProfileUpdateStor = useProfileUpdateStore(function (s) {
    return {
      updateBillingDetails: s.fetch,
      updateBillingDetailsLoading: s.loading
    };
  }),
      updateBillingDetails = _useProfileUpdateStor.updateBillingDetails,
      updateBillingDetailsLoading = _useProfileUpdateStor.updateBillingDetailsLoading;

  var _useProfileStore = useProfileStore(function (s) {
    return {
      profileData: s.data,
      fetchProfileDetails: s.fetch,
      profileDetailsLoaded: s.loaded
    };
  }),
      fetchProfileDetails = _useProfileStore.fetchProfileDetails,
      profileData = _useProfileStore.profileData,
      profileDetailsLoaded = _useProfileStore.profileDetailsLoaded;

  var _useApiCall = useApiCall(fetchUserGeoLocation),
      userLocationResp = _useApiCall[0],
      getUserLocation = _useApiCall[1];

  var _ref = userLocationResp || {},
      userLocation = _ref.data,
      userLocationErorr = _ref.error,
      userLocationCompleted = _ref.completed;
  /* Fetch users profile/address details */


  useEffect(function () {
    pdt.setCommonKeys({
      lobName: lobName
    });

    if (!getOnceSession()) {
      if (isUserTokenPresent()) {
        fetchProfileDetails({
          platform: 'dweb',
          onError: function onError() {
            setEditMode(true);
          }
        });
      } else {
        onLoad == null ? void 0 : onLoad({
          componentVisible: true
        });
        setShowForm(true);
      }
    } else {
      onLoad == null ? void 0 : onLoad({
        componentVisible: false
      });
    } // TODO: save this call if address not present


    getUserLocation();
  }, []);
  /* auto fill user's state from location api */

  useEffect(function () {
    if (!userLocationErorr && userLocationCompleted) {
      var _userLocation$data, _userLocation$data$lo;

      var state = userLocation == null ? void 0 : (_userLocation$data = userLocation.data) == null ? void 0 : (_userLocation$data$lo = _userLocation$data.locationHierarchy) == null ? void 0 : _userLocation$data$lo.state[0];
      setStateListSelected({
        name: state == null ? void 0 : state.name,
        id: state == null ? void 0 : state.id
      });
    } else if (userLocationErorr) {
      setEditMode(true);
    }
  }, [userLocationCompleted, userLocationErorr]);
  /* Fill the input fields with address details given by profile details api */

  useEffect(function () {
    if (profileDetailsLoaded && profileData) {
      var isDetailsPresent = false;
      var addressList = (profileData == null ? void 0 : profileData.addressDetails) || [];
      addressList.forEach(function (item) {
        var category = item.category,
            status = item.status;

        if (category === 'BILLING' && status === 'ACTIVE') {
          isDetailsPresent = true;
          setBillingDetails(item);
          setOnceSession();
        }
      });
      setShowForm(!isDetailsPresent);
      onLoad == null ? void 0 : onLoad({
        componentVisible: !isDetailsPresent
      });
    }
  }, [profileData, profileDetailsLoaded]);

  var onBillingDetailsSaveComplete = function onBillingDetailsSaveComplete() {
    pdt.sendPdtEvent({
      event: 'billing_details_saved_successfully'
    });
    onSuccess({
      state: stateListSelected.name,
      stateId: stateListSelected.id,
      pincode: pincode,
      address: address
    });
  };

  var onUpdateError = function onUpdateError(msg) {
    pdt.sendPdtEvent({
      event: 'billing_details_error',
      item_selected: msg
    });
    setErrorMsg(apiErrorMessage);

    if (onError) {
      onError(true);
    }
  };

  var onSave = function onSave() {
    pdt.sendPdtEvent({
      event: 'billing_details_save_triggered'
    });

    if (getOnceSession()) {
      onBillingDetailsSaveComplete();
      return;
    }

    if (!updateBillingDetailsLoading) {
      setErrorMsg('');
      var isPincodeValid = false;

      if (pincode) {
        isPincodeValid = validatePincode(pincode);

        if (!isPincodeValid) {
          setPincodeErrorMsg(pincodeErrorMessage);
          onError == null ? void 0 : onError(pincodeErrorMessage);
          return;
        }

        setPincodeErrorMsg('');
      }

      if (stateListSelected.name) {
        if (!checkboxVal) {
          setCheckboxError(true);
          onError == null ? void 0 : onError(checkBoxErrorMessage);
          return;
        }

        var data = {
          state: stateListSelected.name,
          address1: address,
          postalCode: pincode,
          category: 'BILLING'
        };

        if (billingDetails != null && billingDetails.addressId) {
          data.addressId = billingDetails.addressId;
        }

        if (!isUserTokenPresent()) {
          // if user is logged out then just send details on success to lobs
          onBillingDetailsSaveComplete();
        } else {
          updateBillingDetails({
            platform: 'dweb',
            data: {
              addressDetails: [data]
            },
            onSuccess: onBillingDetailsSaveComplete,
            onError: onUpdateError
          });
        }
      } else {
        setStateErrorMsg(stateMandatoryMessage);
        onError == null ? void 0 : onError(stateMandatoryMessage);
      }
    }
  };

  useImperativeHandle(ref, function () {
    return {
      onSave: onSave
    };
  });

  var handleState = function handleState(_ref2) {
    var name = _ref2.name,
        id = _ref2.id;
    setStateErrorMsg('');
    setStateListSelected({
      name: name,
      id: id
    });
  };

  var handleAddress = function handleAddress(value) {
    setAddress(value);
  };

  var handlePincode = function handlePincode(value) {
    setPincodeErrorMsg('');
    setPincode(value);
  };

  var handleEdit = function handleEdit() {
    setEditMode(function (value) {
      return !value;
    });
  };

  if (!showForm) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeadingContainer, {
    style: wrapperCss || {}
  }, /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement("div", null, heading, showInfoIcon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BillingIcon, {
    src: "https://gos3.ibcdn.com/gst-billing-1680268365.png",
    className: "billing-icon",
    alt: "billing"
  }), /*#__PURE__*/React.createElement(ToolTip, {
    customClass: "billing-tooltip",
    notchPosition: "right"
  }, /*#__PURE__*/React.createElement("p", null, "You can edit it here or anytime later in your profile section."))) : null), showEditIcon ? /*#__PURE__*/React.createElement(EditKey, {
    onClick: handleEdit
  }, "Edit", /*#__PURE__*/React.createElement(ArrowKey, null)) : null), /*#__PURE__*/React.createElement(SubHeading, null, subHeading), !editMode && platform === Platform.mweb ? /*#__PURE__*/React.createElement(State, null, stateListSelected.name) : /*#__PURE__*/React.createElement(BillingForm, {
    pincodeErrorMsg: pincodeErrorMsg,
    stateListSelected: stateListSelected,
    address: address,
    pincode: pincode,
    handleState: handleState,
    handleAddress: handleAddress,
    handlePincode: handlePincode,
    stateErrorMsg: stateErrorMsg,
    platform: platform
  }), /*#__PURE__*/React.createElement(Checkbox, {
    id: "confirm_check",
    checkboxName: "confirm_check",
    isChecked: checkboxVal,
    isError: checkboxError,
    label: "Confirm and save billing details to your profile",
    checkboxHandler: function checkboxHandler() {
      return setChecboxVal(!checkboxVal);
    },
    extraCss: {
      'font-size': '14px',
      'font-family': 'Helvetica'
    }
  }), !!errorMsg && /*#__PURE__*/React.createElement(ErrorMsg$1, null, errorMsg)));
});
BillingDetails.displayName = 'BillingDetails';

export { BillingDetails as default };
